import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
      description: '上海倾至城科技有限公司专注于科技创新和数字化转型，提供专业的软件开发、技术咨询、系统集成服务。',
      keywords: '科技公司,软件开发,技术咨询,系统集成,数据分析,人工智能'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: {
      title: '关于我们',
      description: '上海倾至城科技有限公司秉承专业、诚信、创新的价值观，致力于为客户提供最高效的科技解决方案与服务。',
      keywords: '倾至城科技,关于我们,公司介绍,发展历程,企业文化'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: {
      title: '产品服务',
      description: '我们提供智能数据分析平台、前沿人工智能算法及定制化系统集成方案，助力各类企业实现高效数字化升级。',
      keywords: '软件产品,数据分析,人工智能,系统集成,数字化升级'
    }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: {
      title: '产品详情',
      description: '上海倾至城科技有限公司产品服务详情。',
      keywords: '软件产品,数据分析,人工智能,系统集成'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: {
      title: '新闻动态',
      description: '获取上海倾至城科技有限公司最新的公司新闻、行业动态以及前沿科技资讯分享。',
      keywords: '公司新闻,行业动态,科技资讯,企业公告'
    }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue'),
    meta: {
      title: '新闻详情',
      description: '获取上海倾至城科技有限公司最新新闻内容。',
      keywords: '公司新闻,行业动态,科技资讯'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: {
      title: '联系我们',
      description: '欢迎联系上海倾至城科技有限公司，了解更多技术服务与定制化解决方案。我们竭诚为您服务。',
      keywords: '联系方式,技术支持,商务合作,公司地址'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// SEO 动态 TDK 设置
router.afterEach((to) => {
  // 设置标题
  const title = to.meta && to.meta.title
    ? `${to.meta.title} - 上海倾至城科技有限公司`
    : '上海倾至城科技有限公司 - 专业科技服务提供商'
  document.title = title

  // 设置 Description
  const description = to.meta && to.meta.description
    ? to.meta.description
    : '上海倾至城科技有限公司专注于科技创新和数字化转型，提供软件开发、技术咨询、系统集成等专业服务'
  const descEl = document.querySelector('meta[name="description"]')
  if (descEl) {
    descEl.setAttribute('content', description)
  }

  // 设置 Keywords
  const keywords = to.meta && to.meta.keywords
    ? to.meta.keywords
    : '科技公司,软件开发,技术咨询,系统集成,数据分析,人工智能'
  const keyEl = document.querySelector('meta[name="keywords"]')
  if (keyEl) {
    keyEl.setAttribute('content', keywords)
  }
})

export default router
